module.exports = __webpack_public_path__ + "img/chat_group_groupOwner01.4b8bc3c7.png";